import type { Narrative } from '../../hooks/useNarrative';

export interface Props {
  companyName: string | null | undefined;
  isSponsored: Narrative['isSponsored'];
}

export const NarrativeSponsoredNotice = ({
  companyName,
  isSponsored,
}: Props) => {
  if (!isSponsored || !companyName) return null;

  return (
    <section className="grid w-full rounded-none bg-surface-1 p-x3 py-x2 lg:rounded-x1">
      <h2 className="m-0 mb-x0_5 line-clamp-2 text-sm font-normal text-softer">
        Sponsored Content Notice
      </h2>
      <p className="m-0 text-xs italic text-soft">
        {`This Narrative has been sponsored by ${companyName} (the Sponsor), which has paid Simply Wall St a fee for its publication on our platform and subsequent promotion. Any relationship between Simply Wall St and ${companyName} does not influence how we produce or moderate other content on this website. The Sponsor has a financial interest in the subject matter of this narrative. Simply Wall St has not independently verified any statements or projections made by the author, and does not endorse or guarantee the accuracy or completeness of the information provided.`}
      </p>
    </section>
  );
};
